import React, { useEffect, useState } from "react";
import "./Gallery.css";
import Navber from "../../Components/Navber";
import ImageLightbox from "../../Components/Helping Component/ImageZoom.jsx";
import api from "../../Api.js";

export default function Gallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await api.get("/happy-customers");
        if (response.data.status) {
          setGalleryData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };
    fetchGalleryData();
  }, []);

  // Flatten all images from all entries
  const allImages = galleryData.flatMap((item) =>
    item.images.map((img) => img.url)
  );

  // Flatten all videos from all entries
  const allVideos = galleryData.flatMap((item) =>
    item.videos.map((video) => video.url)
  );

  // Handler for clicking an image – opens lightbox with all images,
  // putting the clicked one first.
  const handleGalleryOpen = (clickedUrl) => {
    const otherImages = allImages.filter((url) => url !== clickedUrl);
    setCurrentImages([clickedUrl, ...otherImages]);
    setLightboxOpen(true);
  };

  return (
    <>
      <Navber />
      <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />
      <section className="joyraj-gallery-page">
        {/* IMAGE GALLERY */}
        <div className="joyraj-gallery-section">
          <h2>Photo Gallery</h2>
          <div className="joyraj-gallery-grid">
            {allImages.map((url, index) => (
              <div
                className="joyraj-gallery-card"
                key={index}
                onClick={() => handleGalleryOpen(url)}
              >
                <img src={url} alt="Tour Gallery" />
              </div>
            ))}
          </div>
        </div>

        {/* VIDEO GALLERY */}
        <div className="joyraj-gallery-section">
          <h2>Video Gallery</h2>
          <div className="joyraj-gallery-grid joyraj-video-grid">
            {allVideos.map((url, index) => (
              <div className="joyraj-gallery-card joyraj-video-card" key={index}>
                <video src={url} controls muted />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}